import { AccordionSummary, AccordionSummaryProps } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export function Summary(props: AccordionSummaryProps) {
  return <AccordionSummary expandIcon={<ExpandMoreIcon />} {...props} />;
}
